import gql from 'graphql-tag';

export default gql`
  query GetFooterMenu($type: String!) {
    getMenu(type: $type) {
      id
      linksDetails {
        id
        order
        url
        label
        language_code
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/footer/get.js